import { config } from '@/lib/env-helpers';
import '@/styles/loader.css';
import { useworkspaceAuthMeV2Query, WorkspaceStatusEnum } from '@/types/generated/graphql';
import SimpleLoader from '@components/lazy-load/loader';
import { FingerprintJSPro, FpjsProvider } from '@fingerprintjs/fingerprintjs-pro-react';
import { Routers } from '@pages/route';
import { COOKIE_KEY } from '@shared/constants';
import Cookies from 'js-cookie';
import { lazy, Suspense } from 'react';

const AccountSuspendedPage = lazy(() => import('../../../modules/account-suspended/account-suspended.page'));

export const WorkspaceProvider = () => {
  const token = Cookies.get(COOKIE_KEY.accessToken);
  const { loading, data: workspaceAuthMe } = useworkspaceAuthMeV2Query({
    skip: !token,
  });

  if (loading && token) {
    return (
      <div className="w-full min-h-dvh grid place-items-center">
        <div className="page-loader"></div>
      </div>
    );
  }

  if (workspaceAuthMe?.workspaceAuthMeV2?.data?.status === WorkspaceStatusEnum.payment_failed) {
    return (
      <Suspense fallback={<SimpleLoader />}>
        <AccountSuspendedPage />
      </Suspense>
    );
  }

  return (
    <FpjsProvider
      loadOptions={{
        apiKey: config.DEVICE_IDENTITY_KEY,
        endpoint: [config.DEVICE_IDENTITY_PROXY, FingerprintJSPro.defaultEndpoint],
        scriptUrlPattern: [
          // This endpoint will be used primarily
          `${config.DEVICE_IDENTITY_PROXY}/web/v<version>/<apiKey>/loader_v<loaderVersion>.js`,
          // The default endpoint will be used if the primary fails
          FingerprintJSPro.defaultScriptUrlPattern,
        ],
      }}
    >
      <Routers />
    </FpjsProvider>
  );
};
